const colors = {
  primary: '#000000',
  secondary: '#00baa6'
}

export {
  colors
}
